module.exports = __webpack_public_path__ + "img/icon-home.7f7b8103.svg";